import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { BaseService, SettingsService, StorageService } from './core/services';
import { ConfigurationService } from './core/services/configuration.service';
import { filter } from 'rxjs/operators';
import { SeoService } from './core/services/seo.service';
import { SubscriptionService } from './core/services/subscription.service';
import { environment } from 'src/environment';
import { CategoriesService } from './core/services/categories.service';
import { PlanService } from './core/services/plan.service';
import { HomeService } from './core/services/home.service';
import { PlayContentService } from './core/services/play-content.service';
import { ContentService } from './core/services/content.service';
import * as $ from 'jquery';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit, OnInit {
  @ViewChild('hoverkey') hoverKey: ElementRef;
  showHoverCardParentDiv = true;
  title = 'Tv2z-app';
  imagePath;
  showAndroidApp: boolean;
  showIosApp: boolean;
  loading = true;
  hasHistory: boolean;
  pageH1Tag: any;
  guest: boolean;
  showUpdateCard: boolean;
  footerLoad = false;
  orientation;
  value;
  key;
  genreCurationEnabled;
  restrictedUser;
  showHoverData = false;
  cardIMg="";
  playText;
  addWishListText;
  removeWishListText;
  seeInfoText;
  removeListText;
  seasonText;
  episodeText;
  displayOnTitle;
  showTitle = false;
  scrollAddPointer;
  firstCard = 0;
  lastCard = 0;
  cardShrinkTriggering;
  checkingCardPosition;
  mouseMoveListener;
  enableRouting;
  pageDetail;
  dataTitle;
  preventClick = false;
  slickIndex;
  scaling = 'none';
  imageLoadedComplete = false;
  windowWidth;
  DeviceType;
  contentPartner;
  audioSupport = false;
  showAudioPlayer = false;
  AudioPlayerViewSubscriber;
  audioDataObjectSubscriber;
  audioDataObject;
  totalCount;
  component;
  position;
  constructor(private router: Router, public settingsService: SettingsService,private renderer: Renderer2, public contentService: ContentService,
    private baseService: BaseService, private configService: ConfigurationService, private cdRef: ChangeDetectorRef, private dialog:MatDialog,
    public route: ActivatedRoute, private seoService: SeoService, private storageService: StorageService, public playContentService: PlayContentService,
    private subscriptionService: SubscriptionService, private categoryService: CategoriesService, private planService: PlanService, 
     public homeService: HomeService) {
    this.settingsService.showHeader = false;
    if (window.innerWidth > 1024) this.showHoverCardParentDiv = true;
    else this.showHoverCardParentDiv = false;
    this.showAndroidApp = this.baseService.showAndroidApp;
    this.showIosApp = this.baseService.showIosApp;
    this.footerLoad = false;
    this.imagePath = this.settingsService.imagePath;
    this.playText = this.configService.localeKeys?.["player.play_video.btn"];
    this.addWishListText = this.configService.localeKeys?.["my_list.pop_menu_list.text"];
    this.removeWishListText = this.configService.localeKeys?.["my_list.remove.text"];
    this.seeInfoText = this.configService.localeKeys?.["see_info_title"];
    this.removeListText = this.configService.localeKeys?.["my_list.remove_from_list.text"];
    this.seasonText = this.configService.localeKeys?.["sea_dtl_s_letter"];
    this.episodeText = this.configService.localeKeys?.["ep_dtl_e_letter"];
    this.genreCurationEnabled = this.settingsService.genreCurationEnabled;
    this.displayOnTitle = this.settingsService.displayOnTitle;
    this.restrictedUser = environment.isEzProxy || (this.storageService.getLocalStore('hoopla_user') == '1') ? true : false;
    this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(
        () => {
          if (!this.showAndroidApp && !this.showIosApp && this.storageService.getLocalStore('a_t')
            && this.storageService.getLocalStore('r_t') && !this.categoryService.fetchCategoryData &&
            this.settingsService.showHeader) {
            this.categoryService.getNextVersionCategories().subscribe();
          }
          this.handleUTM();
          this.settingsService.getSeo();
          window.scrollTo(0, 0);
        });
    this.baseService.loaderSource.subscribe(data => {
      this.loading = data;
    });
    this.seoService.pageH1Tag.subscribe(data => {
      this.pageH1Tag = data;
    });
    if (this.settingsService.metroOnly) this.settingsService.showHeader = false;
    this.settingsService.showFooter = true;
    this.baseService.guest.subscribe(data => {
      this.guest = data;
    });
    this.baseService.showCardData.subscribe(data => {
      this.showUpdateCard = !data?.no_past_due;
    })
    this.AudioPlayerViewSubscriber = this.playContentService.showAudioPlayer.subscribe(data =>{
      if(data) this.showAudioPlayer = true;
      else this.showAudioPlayer = false;
    })
    this.audioDataObjectSubscriber = this.playContentService.audioContentObject.subscribe(data =>{
      this.audioDataObject = data;
    })
    if(this.settingsService.audioSupported) this.audioSupport = true;
    else this.audioSupport = false;
  }

  ngAfterViewInit() {
    this.cdRef.detectChanges();
    this.loading = false;
    setTimeout(() => {
      this.footerLoad = true;
    }, 2000);
    this.homeService.showHoverCard.subscribe((data) => {
      this.showAndMovehoverCard(data)
    })
    this.homeService.hideHoverCardImmediately.subscribe((data) => {
      if (data) {
        if(this.checkingCardPosition) clearTimeout(this.checkingCardPosition);
        if(this.cardShrinkTriggering) clearTimeout(this.cardShrinkTriggering)
        this.scaling = 'none';
        this.showPrevNextButtonFn(this.slickIndex)
        this.showHoverData = false;
        this.homeService.absoluteCardHovered = false;
      }
    })
    this.homeService.hideHoverCard.subscribe((data) => {
      if (data) {
        this.cardShrinkTriggering = setTimeout(() => {
          this.showPrevNextButtonFn(this.slickIndex)
          this.showHoverData = false;
          this.homeService.absoluteCardHovered = false;
        }, 200);
      }
    })
  }

  ngOnInit():void{}

  @HostListener('window:resize', ['$event'])
  onWindowResize(event: any) {
    if(window.innerWidth > 1024) this.showHoverCardParentDiv = true;
    else this.showHoverCardParentDiv = false;
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event) {
    if (!this.showHoverData) {
      document.documentElement.style.pointerEvents = 'none';
      if(this.scrollAddPointer) clearTimeout(this.scrollAddPointer);
      this.scaling = 'none';
      this.homeService.hideHoverCard.next(true);
      this.scrollAddPointer = setTimeout(() => {
        document.documentElement.style.pointerEvents = 'auto';
      }, 100)
    }
  }

  handleUTM() {
    const params = new URLSearchParams(location.search);
    const urlParams = ['utm_source', 'utm_medium', 'utm_campaign', 'gclid', 'utm_term', 'utm_content'];
    const sessionParams = ['utm_source', 'utm_medium', 'utm_campaign', 'gclid', 'utm_term', 'utm_content'];

    urlParams.forEach(param => {
      const value = params.get(param);
      if (value) {
        this.storageService.setSessionStore(param, value);
      }
    });

    const utm_session_exists = sessionParams.some(param => this.storageService.getSessionStore(param));
    const url_utm_exists = urlParams.some(param => params.get(param));

    if (!url_utm_exists && utm_session_exists) {
      this.settingsService.setUTMFromSession();
    }
  }

  showAndMovehoverCard(data) {
    // if(data?.rect?.width < 180) return;
    this.slickIndex = data.i;
    if ((data.rect || data.value)) {
      if (this.checkingCardPosition) clearTimeout(this.checkingCardPosition);
      if(this.showHoverData) {
        this.scaling = 'none';
        this.homeService.hideHoverCard.next(true)
      }
      this.imageLoadedComplete = false;
        const overlay = this.hoverKey.nativeElement;
        this.firstCard = 0;
        this.lastCard = 0;
        this.orientation = data.orientation;
        this.dataTitle = data.title;
        this.enableRouting = data.enableRouting;
        this.pageDetail = data.pageDetail;
        this.value = data.value;
        this.key = data.key;
        this.contentPartner = data.contentPartner;
        this.totalCount = data.totalCount;
        this.component = data.component;
        this.position = data.position;
        const rect = data.rect;
        if ((this.key !== 'livechannel_widget' && this.key !== 'group_collection_widget' && this.key !== 'top_in_region_widget' && this.key !== 'content_partner_widget')) {
          if ((this.orientation == 2 || this.orientation == 3 ) && this.value?.poster_landscape) {
            this.showTitle = false;
            this.cardIMg = this.settingsService.getImage(this.value.poster_landscape, 'card');
          }
          else if (this.orientation == 1 && this.value?.poster_portrait) {
            this.showTitle = false;
            this.cardIMg = this.settingsService.getImage(this.value.poster_portrait, 'card');
          }
          else if (this.orientation == 1 && !this.value?.poster_portrait  && this.value?.poster_landscape) {
            this.showTitle = false;
            this.cardIMg = this.settingsService.getImage(this.value.poster_landscape, 'card');
          }
          else if (!this.value?.poster_landscape && !this.value?.poster_portrait) {
            this.showTitle = true;
            this.imageLoadedComplete = true;
            this.cardIMg="";
          }

        }
        let metaCard = [];
        if (this.value?.is_series == 1) {
          if (this.value?.publish_time) metaCard.push(this.value?.publish_time)
          if (this.value?.genre && this.genreCurationEnabled == 1) metaCard.push(this.configService.localeKeys?.[this.value?.genre.split(",")[0]]);
          if (this.genreCurationEnabled == 0 && this.value?.tags) metaCard.push(this.value?.tags[0]);
          if (this.value?.total_seasons) {
            let total_seasons = this.value?.total_seasons + " " + (this.value?.total_seasons > 1 ? this.configService.localeKeys?.["common_keys.seasons.text"] : this.configService.localeKeys?.["common_keys.season.text"]);
            metaCard.push(total_seasons);
          }
        }
        if (this.value?.is_series == 0) {
          if (this.value?.publish_time) metaCard.push(this.value?.publish_time)
          if (this.value?.genre && this.genreCurationEnabled == 1)  {
            // in tvod, live channels cards may come in the carousel.Hence this code.
            let genreValue: any;
              genreValue = this.configService.localeKeys?.[this.value?.genre.split(",")[0]];
              metaCard.push(genreValue);
          }
          if (this.genreCurationEnabled == 0 && this.value?.tags) metaCard.push(this.value?.tags[0]);
          if (this.value?.duration_min) metaCard.push(this.transform(this.value?.duration_min))
        }
        let distanceFromLeft = rect.left;
        let distanceFromRight = window.innerWidth - rect.right;
        if (distanceFromLeft < (rect.width)/3) this.firstCard = 1;
        else if (distanceFromRight < (rect.width)/2) this.lastCard = 1;
        else {
          this.firstCard = 0;
          this.lastCard = 0;
        }
        this.value.metaCard = metaCard.join(" | ");
        this.showHoverData = true;
        this.homeService.absoluteCardHovered = true;
        this.hidePrevNextButtonFn(this.slickIndex);
        overlay.style.width = `${rect.width}px`;
        overlay.style.left = `${rect.left + window.scrollX}px`;
        overlay.style.top = `${rect.top + window.scrollY}px`;
        this.scaling = 'scale';
      if(this.mouseMoveListener) this.mouseMoveListener();
      this.checkingCardPosition = setTimeout(() => {
        this.mouseMoveListener = this.renderer.listen(document, 'mousemove', (event: MouseEvent) => this.onMouseMoveOnScreen(event))
      }, 200);
    }
  }

  imageLoaded(){
    this.imageLoadedComplete = true;
  }

  transform(data) {
    let min = data;
    if (min > 60) {
      let hours = Math.floor(min / 60);
      let minutes = min % 60;
      return `${hours} ${this.configService?.localeKeys?.["common_keys.hr_letter.text"] || 'h'} ${minutes} ${this.configService?.localeKeys?.["common_keys.min_letter.text"] || 'm'}`
    } else {
      return `${min} ${this.configService?.localeKeys?.["common_keys.min_letter.text"] || 'm'}`
    }
  }

  showPrevNextButtonFn(index){
    let buttonDiv: HTMLElement = document.querySelector('#slick-'+ index);
    if (buttonDiv) {
      let nextButton: HTMLButtonElement = buttonDiv.querySelector('.slick-next');
      let prevButton: HTMLButtonElement = buttonDiv.querySelector('.slick-prev');
      if (nextButton) nextButton.style.cssText += 'opacity: 1;'
      if (prevButton) prevButton.style.cssText += 'opacity: 1;'
    }
  }

  hidePrevNextButtonFn(index){
    let buttonDiv: HTMLElement = document.querySelector('#slick-'+ index);
    if (buttonDiv) {
      let nextButton: HTMLButtonElement = buttonDiv.querySelector('.slick-next');
      let prevButton: HTMLButtonElement = buttonDiv.querySelector('.slick-prev');
      if (nextButton) nextButton.style.cssText += 'opacity: 0;'
      if (prevButton) prevButton.style.cssText += 'opacity: 0;'
    }  
  }

  stopListening() {
    if (this.mouseMoveListener)  this.mouseMoveListener();
  }

  onMouseMoveOnScreen(event: MouseEvent) {
    clearTimeout(this.checkingCardPosition)
    let mouseX = event.clientX;
    let mouseY = event.clientY;
    let cardPosition = this.hoverKey.nativeElement.getBoundingClientRect();
    if (mouseX >= cardPosition.left && mouseX <= cardPosition.right && mouseY >= cardPosition.top && mouseY <= cardPosition.bottom) {
      this.stopListening()
    } else {
      this.scaling = 'none';
      this.homeService.hideHoverCard.next(true);
      this.stopListening()
    }
  }

  onMouseLeave() {
    if (this.checkingCardPosition) clearTimeout(this.checkingCardPosition);
    this.scaling = 'none';
    this.homeService.hideHoverCard.next(true);
    this.homeService.absoluteCardHovered = false;
  }

  redirect(video, key, title) {
    if (!this.enableRouting) return;

    if (this.checkingCardPosition) clearTimeout(this.checkingCardPosition);
    this.scaling = 'none';
    this.showPrevNextButtonFn(this.slickIndex);
    this.showHoverData = false;
    this.homeService.absoluteCardHovered = false;
    this.homeService.triggerDatamartForHoverCardValue = video;
    this.homeService.triggerDatamartForHoverCard.next(true);

    if (video.is_audio && this.audioSupport) {
      this.handleAudioRedirect(video);
    } else if (video.is_livechannel) {
      this.handleLiveChannelRedirect(video);
    } else if (video.is_series) {
      this.handleSeriesRedirect(video);
    } else if (key === 'video' && this.pageDetail === 'live') {
      this.handleLiveVideoRedirect(video);
    } else {
      this.handleDefaultRedirect(video);
    }

    document.documentElement.style.pointerEvents = 'none';
    setTimeout(() => {
      document.documentElement.style.pointerEvents = 'auto';
    }, 150);
  }

  handleAudioRedirect(video) {
    const collection = {
      totalCount: this.totalCount,
      component: this.component,
      position: this.position
    };
    this.playContentService.selectedContentType.next(video.is_series ? 'podcast' : 'audio');
    this.playContentService.currentContentCollection.next(collection);
    this.playContentService.audioContentObject.next(video);
    this.playContentService.showAudioPlayer.next(true);
  }

  handleLiveChannelRedirect(video) {
    this.closeSearch();
    this.baseService.storeEPGValue(video.slug);
    if (this.settingsService.epgEnabled) this.contentService.autoPlayVideo = true;
    const slug = video?.slug || video?.content_slug;
    this.router.navigate(['/live', slug]);
  }

  handleSeriesRedirect(video) {
    this.closeSearch();
    const seriesSlug = video?.series_slug;
    const seasonSlug = video?.seasons_slug || 'd';
    const contentSlug = video?.content_slug;
    const video_id = video?.video_id;

    if (video.watched_duration) {
      this.contentService.contentSlug = contentSlug;
      this.contentService.seriesSlug = seriesSlug;
      this.contentService.seekValue = video.watched_duration;
    } else {
      this.contentService.seekValue = 0;
    }

    const toRoute = ['/vs', seriesSlug];
    if (video_id && contentSlug && seasonSlug) {
      toRoute.push(seasonSlug, contentSlug);
    }
    this.router.navigate(toRoute);
  }

  handleLiveVideoRedirect(video) {
    this.closeSearch();
    if (this.settingsService.epgEnabled) this.contentService.autoPlayVideo = true;
    this.router.navigate(['/live/player', 'video', video.content_id]);
  }

  handleDefaultRedirect(video) {
    this.closeSearch();
    const route = video?.collection_slug ? ['/v', video.collection_slug, video?.content_slug] : ['/v', video?.content_slug];
    this.router.navigate(route);
  }

  closeSearch(){
    if (this.dialog.openDialogs.length > 0) {
      const clearInput = <HTMLInputElement>document.querySelector(".search-field");
      clearInput.value = '';
      const showSearch = <HTMLInputElement>document.getElementById("searchIcon");
      const showCancel = <HTMLInputElement>document.getElementById("cancelIcon");
      showCancel.style.opacity = '0';
      showSearch.style.opacity = '1';
      showCancel.style.zIndex = '0';
      showSearch.style.zIndex = '1';
      const inputBox = <HTMLInputElement>document.getElementById("inputSearch");
      if (window.innerWidth > 767 && window.innerWidth < 1001) {
        inputBox.setAttribute('style', 'width: 23px ');
        document.getElementById('listCategory').style.display = 'block';
        $('#inputSearch').blur();
      } else {
        inputBox.setAttribute('style', 'width: 280px ')
      }
      this.dialog.closeAll();
    }
  }

  CallingPlayContentService(value , type){
    if(value.is_audio == 1 && type === 'play' && this.audioSupport){
      let collection = {
        totalCount:this.totalCount,
        component:this.component,
        position:this.position
      }
      if(value.is_audio  && value.is_series) this.playContentService.selectedContentType.next('podcast');
      else if(value.is_audio  && !value.is_series) this.playContentService.selectedContentType.next('audio');
      this.playContentService.currentContentCollection.next(collection);
      this.playContentService.audioContentObject.next(value);
      this.playContentService.showAudioPlayer.next(true);
    }else{
      this.closeSearch();
      if(type == 'play'){
        if(this.checkingCardPosition) clearTimeout(this.checkingCardPosition);
        this.scaling='none';
        this.showPrevNextButtonFn(this.slickIndex)
        this.showHoverData = false;
        this.homeService.absoluteCardHovered = false;
        this.playContentService.playVideo(value, 'play');
      }
      else if(type == 'add') this.playContentService.addToWishlist(value);
      else if(type == 'remove') this.playContentService.removeWishlist(value);
    }
  }

  removeContinue(continueId: string) {
    this.preventClick = true;
    this.homeService.removeContinueWatch(continueId).subscribe((data) => {
      if (data) {
        this.preventClick = false;
        this.homeService.updateUserContentFlag = true;
        this.homeService.updateUserContent.next(true);
        this.scaling='none';
        this.showPrevNextButtonFn(this.slickIndex)
        this.showHoverData = false;
        this.homeService.absoluteCardHovered = false;
      }
    });
  }

  domLoaded() {
    this.loading = false;
  }

}
